import * as Yup from 'yup';

import { Designation } from 'interface/designation';

const designationSchema: Yup.ObjectSchema<Designation> = Yup.object({
  id: Yup.number().optional(),
  name: Yup.string()
    .matches(/^[a-zA-Z][\sa-zA-Z/]{1,100}$/, 'Invalid Name')
    .required('Please enter designation name'),
  description: Yup.string()
    .matches(/^[a-z0-9A-Z][\sa-zA-Z/]{1,200}$/, 'Invalid Description')
    .nullable(),
  status: Yup.boolean().optional(),
});

export default designationSchema;
